<template>
  <div
    class="relative flex items-center justify-center mt-8 md:mt-16 mb-8 md:mb-16"
  >
    <NuxtImg
      v-if="standardImage?.PictureUrl && !standardImageHasError"
      :src="standardImage?.PictureUrl"
      alt=""
      sizes="115px md:150px lg:175px"
      class="h-120 md:h-180"
      quality="75"
      format="webp"
      provider="cloudfront"
      :loading="cardIndex >= 10 ? 'lazy' : 'eager'"
      @error="onError"
    />

    <NuxtImg
      v-if="!standardImage?.PictureUrl || standardImageHasError"
      src="/images/product_related/product_placeholder.svg"
      alt=""
      sizes="115px md:150px lg:175px"
      class="min-w-115 h-120 md:h-180"
      :modifiers="{ equalize: true }"
      provider="cloudfront"
    />

    <NuxtImg
      v-if="discountImage"
      :src="`${discountImage?.ImageUrl}`"
      alt=""
      :class="[
        discountImage?.OverlayPLPSmall
          ? `w-[${discountImage.OverlayPLPSmall}dvw]`
          : 'w-[14dvw]',
        discountImage?.OverlayPLPMedium
          ? `md:w-[${discountImage.OverlayPLPMedium}dvw]`
          : 'md:w-[5dvw]',
        discountImage?.OverlayPLPLarge
          ? `3xl:w-[${discountImage.OverlayPLPLarge}dvw]`
          : '3xl:w-[2dvw]',
      ]"
      class="absolute left-[50%] bottom-[-0.8rem] w-64 h-auto md:w-88"
      format="webp"
      quality="75"
      :provider="
        discountImage?.ImageUrl?.includes('cloudfront')
          ? 'cloudfront'
          : undefined
      "
    />

    <NuxtImg
      v-if="condition === GOOD_CONDITION"
      src="/images/product_related/condition_sticker_good.svg"
      alt=""
      class="absolute left-0 bottom-12 md:bottom-24 w-64 h-64 md:w-88 md:h-88"
      sizes="64 md:88"
      provider="cloudfront"
    />

    <NuxtImg
      v-if="condition === PERFECT_CONDITION"
      src="/images/product_related/condition_sticker_perfect.svg"
      alt=""
      class="absolute left-0 bottom-12 md:bottom-24 w-64 h-64 md:w-88 md:h-88"
      sizes="64 md:88"
      provider="cloudfront"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  PERFECT_CONDITION,
  GOOD_CONDITION,
} from '~/models/ListingProduct.api.model';

interface Props {
  cardData?: ProductCard;
  condition?: string;
  cardIndex: number;
}

const props = defineProps<Props>();
const standardImageHasError: Ref<boolean> = ref(false);

function onError() {
  standardImageHasError.value = true;
}

const standardImage = computed(() => props.cardData?.variant.Images?.at(0));

const { discountImage } = useDiscountImage(
  false,
  props.cardData?.bundlePrice?.Discounts,
);
</script>
